import { createFileRoute } from "@tanstack/react-router";
import { AssignmentMatrix } from "@/components/admin/assignment-matrix";

export const Route = createFileRoute("/_auth/app/admin/assignments")({
  component: AssignmentsPage,
});

function AssignmentsPage() {
  return <AssignmentMatrix />;
}
